// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as CatalogRoutes from "./CatalogRoutes.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query products($filterBy: InputProductsQueryFilter)  {\nproducts(filterBy: $filterBy)  {\n__typename  \ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nvariants(first: 50, filterBy: {archived: INCLUDED})  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \ncku  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.products;
  let value$2 = value$1.edges;
  return {
    products: {
      __typename: value$1.__typename,
      totalCount: value$1.totalCount,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.variants;
        let value$3 = value$2.edges;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            variants: {
              __typename: value$2.__typename,
              edges: value$3.map(value => {
                let value$1 = value.node;
                return {
                  __typename: value.__typename,
                  node: {
                    __typename: value$1.__typename,
                    cku: Scalar.CKU.parse(value$1.cku)
                  }
                };
              })
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.products;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.variants;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.cku;
      let value$3 = Scalar.CKU.serialize(value$2);
      let value$4 = value$1.__typename;
      let node = {
        __typename: value$4,
        cku: value$3
      };
      let value$5 = value.__typename;
      return {
        __typename: value$5,
        node: node
      };
    });
    let value$4 = value$2.__typename;
    let variants = {
      __typename: value$4,
      edges: edges
    };
    let value$5 = value$1.__typename;
    let node = {
      __typename: value$5,
      variants: variants
    };
    let value$6 = value.__typename;
    return {
      __typename: value$6,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.__typename;
  let products = {
    __typename: value$4,
    totalCount: value$3,
    edges: edges
  };
  return {
    products: products
  };
}

function serializeInputObjectProductColorEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a === "ORANGE" ? "ORANGE" : (
        a === "RED" ? "RED" : (
            a === "AMBER" ? "AMBER" : (
                a === "DARK" ? "DARK" : (
                    a === "BLACK" ? "BLACK" : (
                        a === "BLOND" ? "BLOND" : (
                            a === "ROSE" ? "ROSE" : "WHITE"
                          )
                      )
                  )
              )
          )
      )
  };
}

function serializeInputObjectProductKindEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a === "SPIRITUOUS" ? "SPIRITUOUS" : (
        a === "BEER" ? "BEER" : (
            a === "WINE" ? "WINE" : "SIMPLE"
          )
      )
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectStringEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeInputObjectInputProductsQueryFilter(inp) {
  let a = inp.name;
  let a$1 = inp.kind;
  let a$2 = inp.producer;
  let a$3 = inp.color;
  let a$4 = inp.variantCkus;
  let a$5 = inp.shopIds;
  let a$6 = inp.archived;
  return {
    name: a !== undefined ? ({
        _equals: a._equals
      }) : undefined,
    kind: a$1 !== undefined ? serializeInputObjectProductKindEqualsFilter(a$1) : undefined,
    producer: a$2 !== undefined ? ({
        _equals: a$2._equals
      }) : undefined,
    color: a$3 !== undefined ? serializeInputObjectProductColorEqualsFilter(a$3) : undefined,
    variantCkus: a$4 !== undefined ? serializeInputObjectInFilter(a$4) : undefined,
    shopIds: a$5 !== undefined ? serializeInputObjectInFilter(a$5) : undefined,
    archived: a$6 !== undefined ? (
        a$6 === "ONLY" ? "ONLY" : (
            a$6 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputProductsQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputProductsQueryFilter(name, kind, producer, color, variantCkus, shopIds, archived, param) {
  return {
    name: name,
    kind: kind,
    producer: producer,
    color: color,
    variantCkus: variantCkus,
    shopIds: shopIds,
    archived: archived
  };
}

function makeInputObjectStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectProductKindEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectProductColorEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let ProductsQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductsQueryFilter: serializeInputObjectInputProductsQueryFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectProductKindEqualsFilter: serializeInputObjectProductKindEqualsFilter,
  serializeInputObjectProductColorEqualsFilter: serializeInputObjectProductColorEqualsFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductsQueryFilter: makeInputObjectInputProductsQueryFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectProductKindEqualsFilter: makeInputObjectProductKindEqualsFilter,
  makeInputObjectProductColorEqualsFilter: makeInputObjectProductColorEqualsFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let useLazy = include.useLazy;

let ProductsQuery_refetchQueryDescription = include.refetchQueryDescription;

let ProductsQuery_use = include.use;

let ProductsQuery_useLazyWithVariables = include.useLazyWithVariables;

let ProductsQuery = {
  ProductsQuery_inner: ProductsQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductsQueryFilter: serializeInputObjectInputProductsQueryFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectProductKindEqualsFilter: serializeInputObjectProductKindEqualsFilter,
  serializeInputObjectProductColorEqualsFilter: serializeInputObjectProductColorEqualsFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductsQueryFilter: makeInputObjectInputProductsQueryFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectProductKindEqualsFilter: makeInputObjectProductKindEqualsFilter,
  makeInputObjectProductColorEqualsFilter: makeInputObjectProductColorEqualsFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: ProductsQuery_refetchQueryDescription,
  use: ProductsQuery_use,
  useLazy: useLazy,
  useLazyWithVariables: ProductsQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query productsByVariantCku($cku: CKU!)  {\nproductsByVariantCku(cku: $cku, filterBy: {archived: INCLUDED})  {\n__typename  \ntotalCount  \n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.productsByVariantCku;
  return {
    productsByVariantCku: {
      __typename: value$1.__typename,
      totalCount: value$1.totalCount
    }
  };
}

function serialize$1(value) {
  let value$1 = value.productsByVariantCku;
  let value$2 = value$1.totalCount;
  let value$3 = value$1.__typename;
  let productsByVariantCku = {
    __typename: value$3,
    totalCount: value$2
  };
  return {
    productsByVariantCku: productsByVariantCku
  };
}

function serializeVariables$1(inp) {
  return {
    cku: inp.cku
  };
}

function makeVariables$1(cku, param) {
  return {
    cku: cku
  };
}

let ProductsByVariantCku_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let ProductsByVariantCku_refetchQueryDescription = include$1.refetchQueryDescription;

let ProductsByVariantCku_use = include$1.use;

let ProductsByVariantCku_useLazy = include$1.useLazy;

let ProductsByVariantCku_useLazyWithVariables = include$1.useLazyWithVariables;

let ProductsByVariantCku = {
  ProductsByVariantCku_inner: ProductsByVariantCku_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  refetchQueryDescription: ProductsByVariantCku_refetchQueryDescription,
  use: ProductsByVariantCku_use,
  useLazy: ProductsByVariantCku_useLazy,
  useLazyWithVariables: ProductsByVariantCku_useLazyWithVariables
};

function runFindingRelevantVariantCku(productsByVariantCkuFetch, variantsCku, variantsCkuActiveIndexOpt, relevantVariantCku, onDone, param) {
  let variantsCkuActiveIndex = variantsCkuActiveIndexOpt !== undefined ? variantsCkuActiveIndexOpt : 0;
  let match = variantsCku[variantsCkuActiveIndex];
  if (match !== undefined) {
    return Future.get(FuturePromise.fromPromise(productsByVariantCkuFetch(match)), response => {
      if (response.TAG !== "Ok") {
        return onDone("Error");
      }
      let match$1 = response._0;
      if (match$1.TAG !== "Ok") {
        return onDone("Error");
      }
      let match$2 = match$1._0;
      if (match$2.error !== undefined) {
        return onDone("Error");
      }
      let totalCount = match$2.data.productsByVariantCku.totalCount;
      let relevantVariantCku$1 = relevantVariantCku !== undefined && relevantVariantCku.productsCount >= totalCount ? relevantVariantCku : ({
          cku: match,
          productsCount: totalCount
        });
      runFindingRelevantVariantCku(productsByVariantCkuFetch, variantsCku, variantsCkuActiveIndex + 1 | 0, relevantVariantCku$1, onDone, undefined);
    });
  } else if (relevantVariantCku !== undefined) {
    return onDone({
      TAG: "Success",
      _0: relevantVariantCku.cku
    });
  } else {
    return onDone("Error");
  }
}

function CatalogProductByCkuPage(props) {
  let __redirectToCreateVariant = props.redirectToCreateVariant;
  let cku = props.cku;
  let redirectToCreateVariant = __redirectToCreateVariant !== undefined ? __redirectToCreateVariant : false;
  let shops = Auth.useShops();
  let authDispatch = Auth.useDispatch();
  let navigate = Navigation.useNavigate();
  let apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let match = useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let queryResults = match[1];
  let executeQuery = match[0];
  let match$1 = React.useState(() => "Loading");
  let setStatus = match$1[1];
  let status = match$1[0];
  React.useEffect(() => {
    let match = shops.length;
    if (match !== 0) {
      if (match !== 1) {
        executeQuery(undefined, undefined, {
          filterBy: makeInputObjectInputProductsQueryFilter(undefined, undefined, undefined, undefined, {
            _in: [cku]
          }, undefined, "INCLUDED", undefined)
        });
      } else {
        setStatus(param => ({
          TAG: "Success",
          _0: cku
        }));
      }
    }
  }, [shops]);
  let productsByVariantCkuFetch = cku => apolloClient.rescript_query({
    query: query$1,
    Raw: Raw$1,
    parse: parse$1,
    serialize: serialize$1,
    serializeVariables: serializeVariables$1
  }, undefined, undefined, "NetworkOnly", undefined, {
    cku: Scalar.CKU.serialize(cku)
  });
  React.useEffect(() => {
    if (queryResults.TAG === "Executed") {
      let match = queryResults._0;
      let match$1 = match.data;
      if (match$1 !== undefined) {
        let match$2 = match$1.products;
        let variantsCku = Stdlib_Option.map(match$2.edges[0], param => param.node.variants.edges.map(param => param.node.cku));
        if (variantsCku !== undefined) {
          if (match$2.totalCount >= shops.length) {
            setStatus(param => ({
              TAG: "Success",
              _0: cku
            }));
          } else if (variantsCku.length !== 1) {
            runFindingRelevantVariantCku(productsByVariantCkuFetch, variantsCku, undefined, undefined, result => {
              authDispatch({
                TAG: "ActiveShopSet",
                _0: undefined
              });
              setStatus(param => result);
            }, undefined);
          } else {
            let cku$1 = variantsCku[0];
            setStatus(param => ({
              TAG: "Success",
              _0: cku$1
            }));
          }
        } else {
          setStatus(param => "Error");
        }
      } else if (match.error !== undefined) {
        setStatus(param => "Error");
      }
    }
  }, [queryResults]);
  if (typeof status !== "object") {
    if (status === "Loading") {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
    } else {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
    }
  }
  let cku$1 = status._0;
  if (redirectToCreateVariant) {
    navigate({
      replace: true
    }, CatalogRoutes.variantCreateRoute(cku$1));
  } else {
    navigate({
      replace: true
    }, CatalogRoutes.productRoute(cku$1));
  }
  return null;
}

let make = React.memo(CatalogProductByCkuPage);

export {
  ProductsQuery,
  ProductsByVariantCku,
  runFindingRelevantVariantCku,
  make,
}
/* query Not a pure module */
